import { Group, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import P2Medium from 'components/typography/P2Medium';
import { ColumnPairing } from 'components/forms/remote-source/config/types';
import ColumnPairingRow from 'components/forms/remote-source/config/ColumnPairingRow';
import { IconPlus } from '@tabler/icons-react';
import { randomId } from '@mantine/hooks';
import { useCallback } from 'react';
import Button from 'components/Button';

interface ColumnPairingsProps<TFormProp, TFormData> {
  formProp: TFormProp;
  form: UseFormReturnType<TFormData>;
  autoNameColumns?: boolean;
  propType: 'device' | 'plan' | 'fault';
}

/**
 * List of column pairings in the modal.
 */
export default function ColumnPairings<TFormProp extends string, TFormData extends Record<TFormProp, ColumnPairing[]>>({
  form,
  formProp,
  autoNameColumns = false,
  propType,
}: ColumnPairingsProps<TFormProp, TFormData>) {
  // A, B, C, ... Z, AA, AB, ...
  const getAutoColumnName = useCallback((index: number) => {
    let columnName = '';
    index += 1; // 1-based index

    while (index > 0) {
      const remainder = (index - 1) % 26;
      columnName = String.fromCharCode(65 + remainder) + columnName;
      index = Math.floor((index - 1) / 26);
    }

    return columnName;
  }, []);

  const gridCols = propType === 'device' ? 'grid-cols-[80px_250px_350px_40px]' : 'grid-cols-[80px_250px_40px]';

  return (
    <Stack spacing={8}>
      <Group>
        <Group className={`grid ${gridCols} items-center gap-y-0`}>
          <P2Medium>Stĺpec</P2Medium>
          <P2Medium>Vlastnosť</P2Medium>
          {propType === 'device' && <P2Medium>Evidenčné pole</P2Medium>}
        </Group>
      </Group>
      {form.values[formProp].map((item, index) => (
        <ColumnPairingRow
          key={item.key}
          form={form}
          formProp={formProp}
          item={item}
          index={index}
          propType={propType}
        />
      ))}
      <Group mt={8}>
        <Button
          size="sm"
          leftIcon={<IconPlus />}
          onClick={() =>
            form.insertListItem(formProp, {
              key: randomId(),
              column: autoNameColumns ? getAutoColumnName(form.values[formProp].length) : '',
            } satisfies ColumnPairing)
          }
        >
          Pridať stĺpec
        </Button>
      </Group>
    </Stack>
  );
}
